module.exports = __webpack_public_path__ + "img/grass-blue.0988c75e.png";